<template>
  <div class="h-dialogContainer">
    <div>
      <BaseBusiness :formParams='formParamsBase' :reMountPage='reMount' ref="base"></BaseBusiness>
    </div>
  </div>
</template>

<script>
import BaseBusiness from './U_BaseBusiness';
import SubscriberArr from '../../../../plugins/subscriberArr';

export default {
  name: 'AddVpnInfoDialog',
  components: {
    BaseBusiness
  },
  data() {
    return {
      opCode: '',
      formParamsBase: {
        json: '',
        formId: `${this.opCode}baseBussiness`,
        subObject: '',
        modelName: 'noGroup',
      },
      params: {
        vpnname: '',
        orgcode: ''
      }
    };
  },
  methods: {
    mainHandler(data, response, propinfo,vpnLevel) {
      const $this = this;
      $this.opCode = propinfo.opCode;
      let subscriberArr = null;
      let arrBase = null;
      const res = response.data.resultVal;
      let bussinessMap = new Map();
      subscriberArr = new SubscriberArr(res, 1);
      // _addFlag -1:批量添加 0:添加 1:修改 2:批量修改
      $this.opCode = propinfo.opCode;
      debugger;
      if(vpnLevel !== '1')
      {
        res.forEach((item) => {
          if(item.name.indexOf('groupCount') > -1 || item.name.indexOf('userCount') > -1 || item.name.indexOf('audioMax') > -1 || item.name.indexOf('videoMax') > -1)
          {
            item.hidden = true;
            item.modifyShow = false;
          }
        });
      }
      if (propinfo.opCode === 'mod') {
        subscriberArr.setDatas(data);
        bussinessMap = subscriberArr.getTempletByGroup(1);
      } else if (propinfo.opCode === 'add') {
        bussinessMap = subscriberArr.getTempletByGroup(0);
      }
      arrBase = bussinessMap.get($this.formParamsBase.modelName);
      $this.formParamsBase.json = arrBase;
      $this.formParamsBase.formId = `${propinfo.opCode}baseBusiness`;
      $this.formParamsBase.subObject = subscriberArr;
      $this.reMount();
    },
    reMount() {
      this.$refs.base.reMount();
    },
    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false ? this.$refs.base.validateResult() : true;
      if (!validateReturn) {
        console.log('表单验证不通过');
        return;
      }
      const map = this.$refs.base.getDatas();
      return map;
    },
  }
};
</script>

<style scoped>

</style>
